import { useMutation } from "@tanstack/react-query";
import { uploadMedicalRecordRequestDocument } from "#/api/medical-record-requests.api";

export function useUploadMedicalRecordRequestDocument() {
  return useMutation({
    mutationKey: ["medical-record-requests", "upload-document"],
    mutationFn: ({ id, file }: { id: string; file: File }) =>
      uploadMedicalRecordRequestDocument(id, file),
  });
}

export default useUploadMedicalRecordRequestDocument;
